import { Document, Page, Text, View } from "@react-pdf/renderer";
import { convertDateFormat, convertOnlyDateFormat, formatMidasNumber } from "../../../global";
import PrintShippingRequest from "./PrintShippingRequest";
import { styles } from "./PrintStylesheet";
import { WORK_REQUEST_TYPES_ENUM } from "./constants";

export default function PrintWorkRequest({
  workRequest,
  shippingRequest,
  shippingAddress,
  workRequestSamples,
  methods,
  billingList,
  dotHazardClass,
}) {
  const usingShipping = false;

  const nonChemicalItems = shippingRequest?.shippingItems.filter(
    (i) => i.containerID === null && !!i.description
  );
  const jadeDescription =
    billingList.find((f) => f.costCode === workRequest.chargeCode)
      ?.description ?? "";
  const jadeText = `${workRequest.chargeCode && workRequest.chargeCode !== 'null' ? workRequest.chargeCode : ""}${jadeDescription ? " ~ " + jadeDescription : ""}`

  const mountComments = (comments) => {
    let comment = "";
    comments.forEach((item) => {
      comment += item + "\n";
    });
    return comment;
  };
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View>
          <Text style={styles.title}>Request Details - {workRequest.id}</Text>
          <View>
            <Text style={styles.subtitle}>Work Request Common Info</Text>
            <View style={styles.tableDivider} />

            <View style={styles.row1}>
              <View style={styles.item50}>
                <Text style={styles.textHeader}>Requester</Text>
                <Text style={styles.text}>{workRequest.requestedByEmail}</Text>
              </View>
              <View style={styles.item50}>
                <Text style={styles.textHeader}>Assigned to</Text>
                <Text style={styles.text}>{workRequest.assignedToEmail}</Text>
              </View>
            </View>
            <View style={styles.row1}>
              <View style={styles.item25}>
                <Text style={styles.textHeader}>Category</Text>
                <Text style={styles.text}>{workRequest.typeName}</Text>
              </View>
              <View style={styles.item25}>
                <Text style={styles.textHeader}>Facility</Text>
                <Text style={styles.text}>{workRequest.facilityName}</Text>
              </View>

              <View style={styles.item25}>
                <Text style={styles.textHeader}>Status</Text>
                <Text style={styles.text}>{workRequest.statusName}</Text>
              </View>
              <View style={styles.item25}>
                <Text style={styles.textHeader}>Business Unit</Text>
                <Text style={styles.text}>{workRequest.businessUnitName}</Text>
              </View>
            </View>
            <View style={styles.row1}>
              <View style={styles.item25}>
                <Text style={styles.textHeader}>Jade Number</Text>
                <Text
                  style={styles.text}
                >{jadeText}</Text>
              </View>
              <View style={styles.item25}>
                <Text style={styles.textHeader}>Created Date</Text>
                <Text style={styles.text}>
                  {convertDateFormat(workRequest.createdDate)}
                </Text>
              </View>
              <View style={styles.item25}>
                <Text style={styles.textHeader}>Last Modified Date</Text>
                <Text style={styles.text}>
                  {convertDateFormat(workRequest.lastModifiedDate)}
                </Text>
              </View>
              <View style={styles.item25}>
                <Text style={styles.textHeader}></Text>
                <Text style={styles.text}></Text>
              </View>
            </View>
            <View style={styles.row1}>
              <View style={styles.item25}>
                <Text style={styles.textHeader}>SMG Priority</Text>
                <Text style={styles.text}>{workRequest.priorityName}</Text>
              </View>
              <View style={styles.item25}>
                <Text style={styles.textHeader}>Request Completition Date</Text>
                <Text style={styles.text}>
                  {convertOnlyDateFormat(workRequest.requestedCompletionDate)}
                </Text>
              </View>
              <View style={styles.item25}>
                <Text style={styles.textHeader}>Last Acceptable Date</Text>
                <Text style={styles.text}>
                  {convertDateFormat(workRequest.lastAcceptableCompletionDate)}
                </Text>
              </View>
              <View style={styles.item25}>
                <Text style={styles.textHeader}>Date Completed</Text>
                <Text style={styles.text}>
                  {convertDateFormat(workRequest.completedDate)}
                </Text>
              </View>
            </View>
            <View style={styles.row1}>
              <View style={styles.item100}>
                <Text style={styles.textHeader}>SMG Priority Reason</Text>
                <Text style={styles.text}>{workRequest.priorityReason}</Text>
              </View>
            </View>

            <View wrap={false} style={styles.row1}>
              <View style={styles.item100}>
                <Text style={styles.textHeader}>Request Description</Text>
                <Text style={styles.text}>{workRequest.description}</Text>
              </View>
            </View>
            <View wrap={false} style={styles.row1}>
              <View style={styles.item100}>
                <Text style={styles.textHeader}>Comments</Text>
                <Text style={styles.text}>
                  {workRequest.comments
                    ? mountComments(workRequest.comments.split("|"))
                    : ""}
                </Text>
              </View>
            </View>
            <Text style={styles.subtitle}>Sample Info</Text>
            <View style={styles.tableDivider} />
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={[styles.tableText, styles.item10]}>MIDAS #</Text>
                <Text style={[styles.tableText, styles.item10]}>
                  Container #
                </Text>
                <Text style={[styles.tableText, styles.item30]}>
                  Description
                </Text>
                <Text style={[styles.tableText, styles.item10]}>PSIMS ID</Text>
                <Text style={[styles.tableText, styles.item10]}>
                  Split Size
                </Text>
                <Text style={[styles.tableText, styles.item10]}>UoM</Text>
                <Text style={[styles.tableText, styles.item10]}>
                  Amt. Available
                </Text>
                <Text style={[styles.tableText, styles.item10]}>
                  Final Location
                </Text>
              </View>
              {workRequestSamples.map((x, index) => {
                const container = x.newContainer ?? x.existingContainer ?? null;
                let locationName = container?.locationName
                  ? container.locationName
                  : `${x.requestedLocationName}${x.deliveryLocationSublocation ? ` | ${x.deliveryLocationSublocation}` : ""}`

                if (workRequest.typeName === WORK_REQUEST_TYPES_ENUM.ON_SITE_TRANSPORT) {
                  locationName = `${x.requestedLocationName ?? ""}`
                }

                return (
                  <View style={styles.tableRow} key={`view-samples-${index}`} wrap={false}>
                    <Text style={[styles.tableText, styles.item10]}>
                      {formatMidasNumber(x.sample?.sampleName)}
                    </Text>
                    <Text style={[styles.tableText, styles.item10]}>
                      {container?.containerNumber ?? "Any"}
                    </Text>
                    <Text style={[styles.tableText, styles.item30]}>
                      {x?.blindCodeDescription ?? x?.sample?.description}
                    </Text>
                    <Text style={[styles.tableText, styles.item10]}>
                      {x.sample?.psimsid}
                    </Text>
                    <Text style={[styles.tableText, styles.item10]}>
                      {container?.size}
                    </Text>
                    <Text style={[styles.tableText, styles.item10]}>
                      {container?.containerSizeUoM}
                    </Text>
                    <Text style={[styles.tableText, styles.item10]}>
                      {container?.currentAmount} {container?.containerSizeUoM}
                    </Text>
                    <Text style={[styles.tableText, styles.item10]}>
                      {locationName}
                    </Text>
                  </View>
                )
              })}
            </View>
            {!!methods?.length && (
              <>
                <Text style={styles.subtitle}>Test Methods Info</Text>
                <View style={styles.tableDivider} />
                <View wrap={false} style={styles.table}>
                  <View style={styles.tableRow}>
                    <Text style={[styles.tableText, styles.item10]}>
                      Method
                    </Text>
                    <Text style={[styles.tableText, styles.item30]}>
                      Method Description
                    </Text>
                    <Text style={[styles.tableText, styles.item10]}>
                      Facility
                    </Text>
                    <Text style={[styles.tableText, styles.item10]}>
                      Condition Offering
                    </Text>
                    <Text style={[styles.tableText, styles.item10]}>
                      Estimate
                    </Text>
                    <Text style={[styles.tableText, styles.item10]}>
                      Priority
                    </Text>
                  </View>
                  {methods.map((x) => (
                    <View style={styles.tableRow}>
                      <Text style={[styles.tableText, styles.item10]}>
                        {x.method.name}
                      </Text>
                      <Text style={[styles.tableText, styles.item30]}>
                        {x.method ? x.method.description : ""}
                      </Text>
                      <Text style={[styles.tableText, styles.item10]}>
                        {x.methodFacility.testFacilityAbv}
                      </Text>
                      <Text style={[styles.tableText, styles.item10]}>
                        {x.conditionOffering?.conditionOfferingName ?? ""}
                      </Text>
                      <Text style={[styles.tableText, styles.item10]}>
                        {x.estimate ? x.estimate : ""}
                      </Text>
                      <Text style={[styles.tableText, styles.item10]}>
                        {x.testPriority.testPriorityName}
                      </Text>
                    </View>
                  ))}
                </View>
              </>
            )}

            {usingShipping && (
              <View wrap={false}>
                <Text style={styles.subtitle}>Shipping Non-chemical Items</Text>
                <View style={styles.tableDivider} />
                <View style={styles.table}>
                  <View style={styles.tableRow}>
                    <Text style={[styles.tableText, styles.item60]}>
                      Description
                    </Text>
                    <Text style={[styles.tableText, styles.item20]}>
                      Quantity
                    </Text>
                    <Text style={[styles.tableText, styles.item20]}>UoM</Text>
                  </View>
                  {nonChemicalItems?.map((x) => (
                    <View style={styles.tableRow}>
                      <Text style={[styles.tableText, styles.item60]}>
                        {x.description}
                      </Text>
                      <Text style={[styles.tableText, styles.item20]}>
                        {x.quantity}
                      </Text>
                      <Text style={[styles.tableText, styles.item20]}>
                        {x.quantityUoMName}
                      </Text>
                    </View>
                  ))}
                </View>
              </View>
            )}
            {usingShipping && (
              <PrintShippingRequest workRequestSamples={workRequestSamples} shippingRequest={shippingRequest} shippingAddress={shippingAddress} dotHazardClass={dotHazardClass} workRequest={workRequest} />
            )}
          </View>
        </View>
      </Page>
    </Document>
  );
}
